import React, { useContext, useEffect, useState } from 'react';
import styles from './Checkout.module.css';
import MainHeader from '../../Components/Header/MainHeader';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../Store/AuthContext';
import { Link, useNavigate, useParams } from 'react-router';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';
import { debounce } from "lodash";

const Checkout = () => {
    const { storeKey } = useParams();
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;
    const loginData = JSON.parse(authCtx.loginData);
    const [isUpdating, setIsUpdating] = useState(false)
    const [isReadyToPlaceOrder, setIsReadyToPlaceOrder] = useState(false)
    const nav = useNavigate()


    const [selectedAddress, setSelectedAddress] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [addresses, setAddresses] = useState([
        { id: 1, label: 'Home', details: '123 Street, City, State, 123456' },
        { id: 2, label: 'Work', details: '456 Avenue, City, State, 654321' },
    ])
    const [cartItems, setCartItems] = useState([
        { id: 1, name: 'Product 1', quantity: 2, mrp: 500 },
        { id: 2, name: 'Product 2', quantity: 1, mrp: 300 },
    ])

    const totalAmount = cartItems.reduce((acc, item) => acc + item.mrp * item.quantity, 0);

    /// pds
    const [gettingPds, setGettingPds] = useState(false)
    const [activeSchemes, setActiveSchemes] = useState([])
    const [tppp, setTppp] = useState(0)


    // place order
    const [isPlacingOrder, setIsPlacingOrder] = useState(false)


    const getCartItems = async () => {
        const response = await fetch(BASE_URL_API + "getCartItems", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                userIdentifier: loginData.userIdentifier,
            }),
        });

        if (!response.ok) {
            console.log("Server Error");
        } else {
            const data = await response.json();
            if (data.status === "success") {
                setCartItems(data?.response);
            } else {
                if (data.message === "token Expired, please login again!") {
                    authCtx.logout();
                } else {
                    setCartItems([]);
                }
            }
        }
    };

    const getUserAddresses = async () => {
        const response = await fetch(BASE_URL_API + "getUserAddresses",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData.userIdentifier,
                }),
            });

        if (!response.ok) {
            console.log("Server Error");
        } else {
            const data = await response.json();
            if (data.status === "success") {
                setAddresses(data.response);
            } else {
                if (data.message === "token Expired, please login again!") {
                    authCtx.logout();
                } else {
                    setAddresses([]);
                }
            }
        }
    };

    const updateCart = async (k, direction) => {
        console.log(k)
        setIsUpdating(true);
        const updateCartResponse = await fetch(BASE_URL_API + "updateCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier: k,
                    direction: direction
                }),
            });

        if (!updateCartResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const updateCartRespo = await updateCartResponse.json();
            if (updateCartRespo.status === "success") {
                getCartItems(); // Refresh cart items
            } else {
                console.log(updateCartRespo);
            }
        }
        setIsUpdating(false);
    };

    const handleIncrease = (k) => {
        updateCart(k, 'increase');
    };

    const handleDecrease = (k) => {
        updateCart(k, 'decrease')
    };

    useEffect(() => {
        getUserAddresses()
        getCartItems().then(() => getActivePds())
    }, [])

    const getActivePds = async () => {
        setGettingPds(true);

        const getActivePdsResponse = await fetch(BASE_URL_API + "getActivePdsForCheckout",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    clientIdentifier: loginData.clientIdentifier
                }),
            });

        if (!getActivePdsResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const getActivePdsRespo = await getActivePdsResponse.json();
            if (getActivePdsRespo.status === "success") {
                setActiveSchemes(getActivePdsRespo?.response); // Refresh cart items
            } else {
                setActiveSchemes([])
            }
            console.log(getActivePdsRespo);
        }
        setGettingPds(false);
    };

    useEffect(() => {
        if (activeSchemes.length > 0) {
            setTppp(cartItems.reduce((acc, item) => acc + item.rewardPoints * item.quantity, 0))
        }
    }, [cartItems, activeSchemes])

    const placeOrder = async () => {
        setIsPlacingOrder(true);
        const placeOrderResponse = await fetch(BASE_URL_API + "placeOrder",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData.userIdentifier,
                    clientIdentifier: loginData.clientIdentifier,
                    productsData: cartItems,
                    addressData: selectedAddress,
                    paymentMethod: paymentMethod,
                    deliveryCharges: 50,
                }),
            });

        if (!placeOrderResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const placeOrderRespo = await placeOrderResponse.json();
            if (placeOrderRespo.status === "success") {
                // console.log(placeOrderRespo);
                nav(`/order-placed/success/${placeOrderRespo?.response?.orderIdentifier}`)
            } else {
                console.log(placeOrderRespo);
            }
        }
        setIsPlacingOrder(false);


    }


    const handleQuantityChange = (quantity, cartItemIdentifier) => {
        setCartItems((prevCartItems) =>
            prevCartItems.map((item) =>
                item.cartItemIdentifier === cartItemIdentifier
                    ? { ...item, quantity }
                    : item
            )
        );

        debounceUpdateQuantityHandler(quantity, cartItemIdentifier);
    };

    const debounceUpdateQuantityHandler = debounce(async (quantity, cartItemIdentifier) => {
        try {
            const payload = { token: authCtx.token, cartItemIdentifier, quantity };
            const response = await fetch(BASE_URL_API + 'updateItemQuantity',
                {
                    method: 'POST',
                    body: JSON.stringify(payload),
                });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to update the cart item.");
            }
            if (result.status !== "success") {

            }
            console.log(result)
        } catch (error) {
            console.error("Error updating quantity:", error.message);
        }
    }, 500);

    // Clean up debounce on component unmount
    useEffect(() => {
        return () => {
            debounceUpdateQuantityHandler.cancel();
        };
    }, []);


    const updateQuantityHandler = async (quantity, cartItemIdentifier) => {
        try {
            // 1. Validate input
            if (quantity < 1) {
                alert("Quantity must be at least 1.");
                return;
            }
            handleQuantityChange(quantity, cartItemIdentifier)
        } catch (error) {
            // 6. Handle errors
            console.error("Error updating quantity:", error.message);
            alert("Unable to update the cart item. Please try again later.");
        }
    };


    useEffect(() => {
        if(paymentMethod!=='') {
            if(cartItems.length>0) {
                if(selectedAddress!==null) {
                    setIsReadyToPlaceOrder(true)
                } else {
                    setIsReadyToPlaceOrder(false)
                }
            } else {
                setIsReadyToPlaceOrder(false)
            }
        } else {
            setIsReadyToPlaceOrder(false)
        }
    }, [paymentMethod, cartItems, selectedAddress])
    
    console.log(isReadyToPlaceOrder)


    return (
        <div className={styles.checkoutPage}>
            <MainHeader cartItems={cartItems} />

            <div className={styles.mainContainer}>
                <div className={styles.leftColumn}>

                    {/* Address Section */}
                    <div className={styles.addressSection}>
                        <div className={styles.sectionTitle} >
                            Select Delivery Address
                            <div>
                                <button className={styles.addMoreAddress} ><FaPlus />Add New</button>
                            </div>
                        </div>
                        <div className={styles.addressList} >

                            {addresses.map((address) => (
                                <div
                                    key={address.id}
                                    className={`${styles.addressCard} ${selectedAddress?.addressIdentifier === address.addressIdentifier ? styles.selected : ''}`}
                                    onClick={() => setSelectedAddress(address)}
                                >
                                    <div>{address.fullName}</div>
                                    <div className={styles.fullAddress} >{address.address}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Cart Summary */}
                    <div className={styles.cartSummary}>
                        <div className={styles.sectionTitle} >Cart Summary
                            <div>
                                <Link to={`/${storeKey}/shop`} className={styles.addMoreAddress} ><FaPlus />Add More</Link>
                            </div>
                        </div>
                        {cartItems.map((item) => (
                            <div key={item.cartItemIdentifier} className={styles.cartItem}>
                                <span className={styles.name} >{item.productTitle}</span>
                                <div className={styles.quantityPrice}>
                                    <div className={styles.quantity} >
                                        <div className={styles.quantAction} onClick={() => handleDecrease(item?.cartItemIdentifier)} ><FaMinus size={14} /></div>
                                        <div className={styles.quantValue}>
                                            <input
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) => updateQuantityHandler(e.target.value, item?.cartItemIdentifier)}
                                                className={styles.quantityInput}
                                            />
                                        </div>
                                        <div className={styles.quantAction} onClick={() => handleIncrease(item?.cartItemIdentifier)} ><FaPlus size={14} /></div>
                                    </div>
                                    <div className={styles.price} >₹{item.mrp * item.quantity}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Payment Options */}
                    <div className={styles.paymentSection}>
                        <div className={styles.sectionTitle} >Payment Method</div>
                        <div className={styles.paymentOptions}>
                            <div className={styles.paymentOption}
                                onClick={() => setPaymentMethod(`PO`)}
                            >
                                <div className={styles.paymentIcon}>
                                    {paymentMethod === 'PO' ? <MdRadioButtonChecked size={22} /> : <MdRadioButtonUnchecked size={22} />}
                                </div>
                                <div>
                                    Raising PO
                                </div>
                            </div>
                            <div className={styles.paymentOption}
                                onClick={() => setPaymentMethod(`CreditCard`)}
                            >
                                <div className={styles.paymentIcon}>
                                    {paymentMethod === 'CreditCard' ? <MdRadioButtonChecked size={22} /> : <MdRadioButtonUnchecked size={22} />}
                                </div>
                                <div>
                                    Credit/Debit Card
                                </div>
                            </div>
                            <div className={styles.paymentOption}
                                onClick={() => setPaymentMethod(`UPI`)}
                            >
                                <div className={styles.paymentIcon}>
                                    {paymentMethod === 'UPI' ? <MdRadioButtonChecked size={22} /> : <MdRadioButtonUnchecked size={22} />}
                                </div>
                                <div>
                                    UPI
                                </div>
                            </div>
                            <div className={styles.paymentOption}
                                onClick={() => setPaymentMethod(`Wallet`)}
                            >
                                <div className={styles.paymentIcon}>
                                    {paymentMethod === 'Wallet' ? <MdRadioButtonChecked size={22} /> : <MdRadioButtonUnchecked size={22} />}
                                </div>
                                <div>
                                    Wallet
                                </div>
                            </div>
                            <div className={styles.paymentOption}
                                onClick={() => setPaymentMethod(`COD`)}
                            >
                                <div className={styles.paymentIcon}>
                                    {paymentMethod === 'COD' ? <MdRadioButtonChecked size={22} /> : <MdRadioButtonUnchecked size={22} />}
                                </div>
                                <div>
                                    COD
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
                <div className={styles.rightColumn}>
                    {/* Order Summary */}
                    <div className={styles.orderSummary}>
                        <div className={styles.sectionTitle} >Order Summary</div>
                        <div className={styles.subTotal}>
                            <span>Subtotal</span>
                            <span>₹{totalAmount}</span>
                        </div>
                        <div className={styles.deliveryCharges}>
                            <span>Delivery Charges</span>
                            <span>₹50</span>
                        </div>
                        <div className={styles.total}>
                            <span>Total</span>
                            <span>₹{totalAmount + 50}</span>
                        </div>
                    </div>

                    {/* Rewards Points Section */}
                    <div className={styles.orderSummary}>
                        <div className={styles.sectionTitle} >Rewards Points</div>
                        <div>
                            {activeSchemes?.map((item, index) => (
                                <div key={index} className={styles.eachScheme}>
                                    <div className={styles.pdsTitle}>
                                        {item?.pdsTitle}
                                        <div className={styles.pdsMessage}>
                                            You are eligible to get {tppp} reward points on this purchase
                                        </div>
                                    </div>
                                    <div className={styles.points}>
                                        +{tppp}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Sticky Bottom Nav */}
                    <div className={styles.stickyFooter}>
                        <button className={styles.placeOrderButton} disabled={!isReadyToPlaceOrder} onClick={() => placeOrder()} >Place Order</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;
